export default __webpack_public_path__ + "static/media/element_spec_70.3af221e0.jpg";